import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  Icon,
  Text,
  Heading,
  TextWithTooltip
} from 'components/common/Elements/Elements';
import { protocolsColor } from 'utils/common';

import classes from './PlatformApplication.module.scss';

const PlatformApplication = ({ app }) => {
  return (
    <div className={classes.application}>
      <div className={classes.appName}>
        <div className={classes.iconHttp}>
          <Icon
            size="16px"
            icon={app.protocol}
            color={protocolsColor[app.protocol]}
          />
        </div>
        <div className={classes.appName_nameWrap}>
          <div className={classes.appName}>
            <div className={classes.overflow}>
              <Heading className={cn(classes.appName_name, classes.overflow)}>
                <TextWithTooltip text={app.appName} />
              </Heading>
            </div>
            <Text
              className={cn(classes.appName_protocol, classes[app.protocol])}
              weight="b"
            >
              {app.protocol}
            </Text>
          </div>
          <div className={classes.overflow}>
            <Text className={classes.appName_host}>
              <TextWithTooltip text={app.host} />
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

PlatformApplication.propTypes = {
  app: PropTypes.object
};

export default PlatformApplication;
